
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cQLav", function(module, exports) {

var $4H1Ss = parcelRequire("4H1Ss");


var $2pPu4 = parcelRequire("2pPu4");


var $b7iDu = parcelRequire("b7iDu");


var $jFuuN = parcelRequire("jFuuN");


var $hEkrl = parcelRequire("hEkrl");


var $eiu0m = parcelRequire("eiu0m");


var $j8txk = parcelRequire("j8txk");


var $jgKBj = parcelRequire("jgKBj");


var $8akCo = parcelRequire("8akCo");


var $5InRj = parcelRequire("5InRj");


var $aWEgY = parcelRequire("aWEgY");


var $1xTLA = parcelRequire("1xTLA");


var $cJRFO = parcelRequire("cJRFO");


var $7apDH = parcelRequire("7apDH");


var $aRzik = parcelRequire("aRzik");


var $71WeF = parcelRequire("71WeF");


var $4QUop = parcelRequire("4QUop");


var $kQuIn = parcelRequire("kQuIn");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $74MFN = parcelRequire("74MFN");

const $1f3601d41c69fdba$export$c0c8ceeb88dd1e08 = {
    displayName: 'Forge GDrive Eugene Test Staging',
    id: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
    icon: (0, $fj6km.get3PLogo)((0, $74MFN.ForgeGdriveEugeneTestDevIcon), 'ForgeGdriveEugeneTestDev', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $74MFN.ForgeGdriveEugeneTestDevSearchResultIcon), 'ForgeGdriveEugeneTestDev', 'large'),
    integrationAri: 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Project,
            {
                entities3P: (0, $aRzik.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kQuIn.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: (0, $jgKBj.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Message,
            {
                entities3P: (0, $7apDH.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $b7iDu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $aWEgY.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $5InRj.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $8akCo.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Space,
            {
                entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $hEkrl.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $eiu0m.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $4H1Ss.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeGdriveEugeneTestDevConfig"] = $1f3601d41c69fdba$export$c0c8ceeb88dd1e08;

});

parcelRegister("4H1Ss", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fbb1aa0fcec8a498$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $fbb1aa0fcec8a498$export$733c2acb2513a07a;

});

parcelRegister("2pPu4", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $7ea03d02d9b5f1e3$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $7ea03d02d9b5f1e3$export$4e0eae9edc1a8907;

});

parcelRegister("b7iDu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $37cdb15be320b628$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $37cdb15be320b628$export$a752b216a5b9069f;

});

parcelRegister("jFuuN", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $6e80f623fe7c0736$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $6e80f623fe7c0736$export$8dd471de1c2be682;

});

parcelRegister("hEkrl", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $e725df1e1e005e82$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $e725df1e1e005e82$export$5794851cbc8ee193;

});

parcelRegister("eiu0m", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a6c1427b73e57501$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $a6c1427b73e57501$export$f752f74515f17189;

});

parcelRegister("j8txk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $686b00cded736086$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $686b00cded736086$export$13c55dcee8605c46;

});

parcelRegister("jgKBj", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $15fa3f0fcc22a9d1$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $15fa3f0fcc22a9d1$export$9d37c36d8b43baee;

});

parcelRegister("8akCo", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $03a6e2b346ada400$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $03a6e2b346ada400$export$7bf025ec33e76761;

});

parcelRegister("5InRj", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4931b703bfc44589$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $4931b703bfc44589$export$3e5409bef2addb56;

});

parcelRegister("aWEgY", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $32dd7299b373890b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $32dd7299b373890b$export$3268f1527392e5ac;

});

parcelRegister("1xTLA", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a839bb0b2176dcbd$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $a839bb0b2176dcbd$export$c28231fcae6448eb;

});

parcelRegister("cJRFO", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $dd0d86a6eef7eeb2$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $dd0d86a6eef7eeb2$export$d520529b4595d46c;

});

parcelRegister("7apDH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a6943bbde389a4af$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $a6943bbde389a4af$export$8bd7fa13a82672fe;

});

parcelRegister("aRzik", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $076b759d60af9206$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
module.exports["DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI"] = $076b759d60af9206$export$3f89e5cd56d4a568;

});

parcelRegister("71WeF", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $8b8c4a19dc45a1eb$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $8b8c4a19dc45a1eb$export$1dc2d469fb044d48;

});

parcelRegister("4QUop", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $9bae9436830d46c0$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $9bae9436830d46c0$export$1e3b02869b42f77a;

});

parcelRegister("kQuIn", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $f2d4a2cb14cdae7d$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $f2d4a2cb14cdae7d$export$a3d7cddace4fe237;

});

parcelRegister("kLIW5", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $406d04c9f0a71eb1$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $406d04c9f0a71eb1$export$d810eae89914369b;

});

parcelRegister("74MFN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("gpwbP")).then((m)=>m.ForgeGdriveEugeneTestDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/icon'
});

const $6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("gpwbP")).then((m)=>m.ForgeGdriveEugeneTestDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/search-result-icon'
});
const $6e1c46cc76d89dd5$export$d25ddeed4ba7332 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
const $6e1c46cc76d89dd5$export$5a35b3e4364deaaf = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1c46cc76d89dd5$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
module.exports["ForgeGdriveEugeneTestDevIcon"] = $6e1c46cc76d89dd5$export$d25ddeed4ba7332;
module.exports["ForgeGdriveEugeneTestDevSearchResultIcon"] = $6e1c46cc76d89dd5$export$5a35b3e4364deaaf;

});

parcelRegister("gpwbP", function(module, exports) {

let $bf27f361099b3af9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf27f361099b3af9$var$load("8e6dL").then(()=>parcelRequire('dv8W3'));

});


//# sourceMappingURL=forge-gdrive-eugene-test-dev.8f722d93.js.map
